import React from 'react';
import { Card, Menu, Bubble, Row, Col } from 'tea-component';
import { useIntl, useParams, getLocale } from 'umi';
import { useCreation } from 'ahooks';
import CardCont from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/Financials/components/CardCont';
import InfoCard from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/Financials/components/InfoCard';
import Loading from '@/pages/intelligence/components/Loading';
import { usePeople } from './hooks';
import { ErrorBox } from '../Financials';
import userDefaultIcon from '@/pages/intelligence/assets/svg/tipicon/kol-default.svg';
import '@/pages/intelligence/assets/scss/TopCharts/Companies/GamesDetails/people.scss';
const People = (props: { [key in string]: unknown }) => {
  const { id } = useParams() as any;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const { data, loading, error } = usePeople(
    useCreation(() => ({ company_id: id }), [id]),
  );
  // 数据源配置
  const configdataList = useCreation(
    () => (id: string) => {
      const list = {
        currentTeams: {
          dataList: [
            {
              id: '0',
              text: formatMessage({ id: 'dbi_company_number_members' }),
              data: data?.currentTeams?.total,
            },
          ],
          title: {
            title: formatMessage({ id: 'dbi_company_current_team' }),
            text: `${props?.basicInfo?.name} ${locale === 'zh-CN' ? "现有" : 'has'}`,
            num: data?.currentTeams?.total,
            message:
              formatMessage({ id: 'dbi_company_andrew_wilson' }, { message: 'Andrew Wilson' })

          },
          cardListTop8: data?.currentTeams?.currentTeams,
        },
        boardAndAdvisors: {
          dataList: [
            {
              id: '0',
              text: formatMessage({ id: 'dbi_company_members_person' }),
              data: data?.boardAndAdvisors?.total,
            },
          ],
          title: {
            title: formatMessage({ id: 'dbi_company_members_advisors' }),
            text: `${props?.basicInfo?.name} ${locale === 'zh-CN' ? "现有" : 'has'}`,
            num: data?.boardAndAdvisors?.total,
            message: formatMessage({ id: 'dbi_company_holdings_members' }, { message: 'Shawn Layden' }),
          },
          cardListTop8: data?.boardAndAdvisors?.currentTeams,
        },
      }[id];
      return list ?? null;
    },
    [data, id, formatMessage, props?.basicInfo?.name, locale],
  );

  if (loading) {
    return <Loading marginTop={300} />;
  }

  // 纯展示，就直接map配置项，没有副作用，不用担心组件性能问题
  return (
    <div className="dbi-people">
      <ErrorBox {...{ error }} />
      {['currentTeams', 'boardAndAdvisors'].map((task, index) => (
        <React.Fragment key={index}>
          <CardCont
            title={
              <div className="dbi-people-head">
                <div className="dbi-people-title">
                  {configdataList(task)?.title.title}
                </div>
                <div className="dbi-people-text">
                  <span>{configdataList(task)?.title.text}</span>
                  <span className="dbi-people-num">
                    {configdataList(task)?.title.num}
                  </span>
                  <span>{configdataList(task)?.title.message}</span>
                </div>
              </div>
            }
            dataList={configdataList(task)?.dataList}
          >
            <Row className="dbi-people-list">
              {configdataList(task)
                ?.cardListTop8?.slice(0, 8)
                ?.map(
                  (e: { id: React.Key | null | undefined }, index: number) => (
                    <Col key={index} span={12}>
                      <InfoCard infoList={e} defaultImg={userDefaultIcon}/>
                    </Col>
                  ),
                )}
            </Row>
          </CardCont>
        </React.Fragment>
      ))}
    </div>
  );
};

export default People;
